import Vue from 'vue'
import Router from 'vue-router'
import oidcCallback from '@/components/common/oidcCallback'
import oidcRenew from '@/components/common/oidcRenew'
import {vuexOidcCreateRouterMiddleware} from 'vuex-oidc'
import store from '../store'

var solution = "default";
var terminal = "workflow";
if (getUrlKey("solution")) {
    solution = getUrlKey("solution");
}
if (getMobile()) {
    terminal = "wechat";
}

Vue.use(Router);

Vue.prototype.$global = () => {
    return {
        solution, terminal
    }
}

var router = new Router({
    mode: "history", // 加上history之后本地build之后router不正常显示，所以先暂时注释
    base: window.commonApi.PATH ? window.commonApi.PATH : '/',
    routes: [
        {
            path: '/',
            redirect: '/workflow/index'
        },
        {
            path: '/home',
            // redirect: '/workflow/index'
            component: resolve => require([`@/views/todoCenter/${solution}/${terminal}/contentsHomeTemplate`], resolve)
        },
        {
            path: '/workflow/index',
            name: 'apps',
            meta: {
                isPublic: false,
            },
            component: resolve => require([`@/views/todoCenter/${solution}/${terminal}/contentsTemplate`], resolve)
        },
        {
            path: '/workflow/searchResult',
            name: 'searchResult',
            meta: {
                isPublic: false,
            },
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsSearchTemplate`], resolve)
        },
        {
            path: '/workflow/home',
            name: 'home',
            component: resolve => require([`@/views/todoCenter/${solution}/${terminal}/contentsHomeTemplate`], resolve)
        },
        {
            path: '/workflow/todo',
            name: 'todo',
            component: resolve => require([`@/views/todoCenter/${solution}/${terminal}/contentsTodoTemplate`], resolve)
        },
        {
            path: '/workflow/doing',
            name: 'doing',
            component: resolve => require([`@/views/todoCenter/${solution}/${terminal}/contentsDoingTemplate`], resolve)
        },
        {
            path: '/workflow/meApply',
            name: 'meApply',
            component: resolve => require([`@/views/todoCenter/${solution}/${terminal}/contentsApplyTemplate`], resolve)
        },
        {
            path: '/workflow/done',
            name: 'done',
            component: resolve => require([`@/views/todoCenter/${solution}/${terminal}/contentsDoneTemplate`], resolve)
        },
        {
            path: '/workflow/flow_cc',
            name: 'flow_cc',
            component: resolve => require([`@/views/todoCenter/${solution}/${terminal}/contentsCcTemplate`], resolve)
        },
        {
            path: '/workflow/favorite',
            name: 'favorite',
            component: resolve => require([`@/views/todoCenter/${solution}/${terminal}/contentsFavoriteTemplate`], resolve)
        },
        {
            path: '/workflow/detail',
            name: 'detail',
            component: resolve => require([`@/views/todoCenter/${solution}/${terminal}/contentsItemDetail`], resolve)
        },
        {
            path: '/workflow/appdetail',
            name: 'appDetail',
            meta: {
                isPublic: false,
            },
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsAppDetailTemplate`], resolve)
        },
        {
            path: '/workflow/serviceCenter',
            name: 'serviceC',
            meta: {
                isPublic: false,
            },
            component: resolve => require([`@/views/todoCenter/${solution}/${terminal}/contentsServiceCenterTemplate`], resolve)
        },
        {
            path: '/workflow/helpcenter',
            name: 'help',
            meta: {
                isPublic: false,
            },
            component: resolve => require([`@/views/todoCenter/${solution}/${terminal}/contentsHelpCenterTemplate.vue`], resolve)
        },
        {
            path: '/workflow/gl/:glId',
            name: 'gl',
            component: resolve => require([`@/views/todoCenter/${solution}/${terminal}/contentsGlTemplate`], resolve)
        },
        {
            path: '/workflow/oidcCallback',
            name: 'oidcCallback',
            component: oidcCallback,
            meta: {
                isVuexOidcCallback: true,
                isPublic: true
            }
        },
        {
            path: '/workflow/oidcRenew',
            name: 'oidcRenew',
            component: oidcRenew
        },
        {
            path: '/signin-oidc-error',
            redirect: '/'
        },
    ]
})

function getMobile() {
    var flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flag === null) {
        return false;
    } else {
        return true;
    }
}

function getUrlKey(name) {
    return (
        decodeURIComponent(
            (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
                location.href
            ) || [, ''])[1].replace(/\+/g, '%20')
        ) || null
    );
}

// 移动端，pc端未登录界面
// router.options.routes.forEach(function (item) {
//     if (item.name == 'apps' || item.name == 'serviceC' || item.name == 'statistics' || item.name == 'help') {
//         // item.meta.isPublic = true;
//     }
// });
// (vuexOidcCreateRouterMiddleware(store, 'oidcStore'));

router.beforeEach((to, from, next) => {
    console.log(to.name, from.name, '-----')
    if(!from.name){
        sessionStorage.setItem('hasSigned', false)
    }
    var notAuth = to.matched.some(record => record.meta.isPublic);
    var hasSigned = sessionStorage.getItem('hasSigned')

    hasSigned = (!hasSigned || hasSigned === 'false') ? false : true;

    let storedUser = Object.keys(localStorage).filter(t=>t.startsWith('oidc.user:') && (window.commonApi.SSO_URL && t.includes(window.commonApi.SSO_URL)));
    if (storedUser.length) {
        sessionStorage.setItem('hasSigned', true);
    }
    // console.log(storedUser, '------', Object.keys(localStorage).filter(t=>t.startsWith('oidc.user:')))
    if (notAuth || (!hasSigned && ['apps','serviceC','appDetail'].includes(to.name))) {
        next();   
    }else{
        // 已登录要一直保持登录，未登录则跳过登录

        let middle = vuexOidcCreateRouterMiddleware(store, "oidcStore"), trends = [];
        middle(to, from, async () => {
            next()
        })
    }

})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js